import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, DialogTitle, IconButton} from "@mui/material";
import ShowPageContent from "../../pages/front/pages/ShowPageContent";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import Title from "./Title";
import {connect, setStore} from "trim-redux";
import CloseIcon from "@mui/icons-material/Close";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";


function TermsButton(props) {
    let [open,setOpen] = useState(false);
    let [page,setPage] = useState(null);
    const { t } = useTranslation();
    const setPageResult = (data) => {
        setPage(data);
    }
    return (
        <>
            <span
                style={{color:props.primary_color}}
                onClick={() => setOpen(true)}
            >
                {t('termsAndConditions')}
            </span>
            <Dialog fullWidth maxWidth='lg' open={open} onClose={() => setOpen(false)}>
                <DialogTitle className="vendor-co-title">
                    <Title align="left" color="text">{t('termsAndConditions')}</Title>
                    <IconButton aria-label="close" className={props.classes.dialogClose} onClick={() => setOpen(false)}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent style={{maxHeight:"55vh"}}>
                    <ShowPageContent slug="terms-and-conditions" setPageData={(data) => setPageResult(data)}/>
                </DialogContent>
            </Dialog>
        </>
    );
}
const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color

});

export default withStyles(Styles)(connect(mstp)(TermsButton));